/* ==========================================================================
   VJ-CORR-D56 — 18 août 2026 — LE € PASSE APRÈS LE MONTANT
   --------------------------------------------------------------------------
   Rachid : « Le € s'affiche après le montant, pas avant. »

   MESURÉ. `shop.money_format` vaut « €{{amount_with_comma_separator}} » et
   sort partout « €120,00 », « €1.400,00 », « €380,00 loin de la livraison
   gratuite ». L'usage français place le symbole après : « 120,00 € ».

   CE FICHIER NE TRAITE QUE LA MOITIÉ DU PROBLÈME, ET C'EST VOULU.
   Le format monétaire est un réglage BOUTIQUE (admin Shopify → Paramètres →
   Général → Devise → formatage), pas un réglage de thème : aucun code du
   thème ne peut le changer à la source. Le correctif définitif est une case
   à cocher dans l'admin, et il couvrira AUSSI le paiement et les e-mails de
   confirmation, que le thème ne touche pas.
     - le JS du thème est traité par js-variables.liquid (marqueurs D56)
     - le rendu Liquid côté serveur est repris ici, à l'affichage
     - le tunnel de paiement reste hors de portée : côté admin uniquement

   PRÉCAUTIONS
     - on ne touche QUE des nœuds de texte : jamais un attribut, jamais la
       valeur d'un champ, jamais le contenu d'un <script> ou d'un <textarea>,
       où une réécriture casserait la donnée envoyée au serveur.
     - l'observateur est débranché pendant l'écriture, sinon ses propres
       modifications le relancent en boucle.
     - la substitution est idempotente : un montant déjà retourné ne porte
       plus de € en tête, donc l'expression ne le reconnaît plus.
   ========================================================================== */
(function () {
  'use strict';

  /* « €120,00 », « € 1.400,00 » — le symbole en tête, puis un montant fait de
     chiffres, points, virgules et espaces insécables. */
  var MONTANT = /€\s*(\d[\d.,  \s]*\d|\d)/g;
  var IGNORE = /^(SCRIPT|STYLE|TEXTAREA|OPTION|SELECT|NOPTION)$/;

  function retourner(txt) {
    return txt.replace(MONTANT, function (_, n) { return n.trim() + ' €'; });
  }

  function balayer(racine) {
    if (!racine || racine.nodeType === 3) racine = document.body;
    if (!racine) return;
    var marcheur = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, null);
    var noeud, aFaire = [];
    while ((noeud = marcheur.nextNode())) {
      var v = noeud.nodeValue;
      if (!v || v.indexOf('€') === -1) continue;
      var p = noeud.parentNode;
      if (!p || IGNORE.test(p.nodeName)) continue;
      var neuf = retourner(v);
      if (neuf !== v) aFaire.push([noeud, neuf]);
    }
    for (var i = 0; i < aFaire.length; i++) aFaire[i][0].nodeValue = aFaire[i][1];
    return aFaire.length;
  }

  var observateur = null;
  var enAttente = false;

  function passer(racine) {
    if (observateur) observateur.disconnect();
    try { balayer(racine); } finally { brancher(); }
  }

  function brancher() {
    if (!observateur || !document.body) return;
    observateur.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function demarrer() {
    if (!document.body) return;
    observateur = new MutationObserver(function () {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () { enAttente = false; passer(document.body); });
    });
    passer(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
